// import { useEffect, useState } from "react";
// import { Bell, Download, ChevronLeft, ChevronRight, FileText, Info } from "lucide-react";
// import Loader from "../Loader";

// const AnnouncementPanel = () => {
//   const [announcements, setAnnouncements] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pagination, setPagination] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [downloading, setDownloading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchAnnouncements = async (page = 1) => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/announcement?page=${page}`);
//       if (!response.ok) throw new Error("Failed to fetch announcements");
//       const data = await response.json();

//       if (data.success && data.data.announcements) {
//         const activeAnnouncements = data.data.announcements.filter((a) => a.isActive);
//         setAnnouncements(activeAnnouncements);
//         setPagination(data.data.pagination);
//       } else {
//         setError("No active announcements found");
//       }
//     } catch (err) {
//       console.error("Error fetching announcements:", err);
//       setError(err.message || "Error fetching announcements");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAnnouncements(currentPage);
//   }, [currentPage]);

//   const handleDownload = async (fileUrl) => {
//     try {
//       setDownloading(true);
//       const response = await fetch(fileUrl);
//       if (!response.ok) throw new Error("Failed to download file");

//       const blob = await response.blob();
//       const fileName = fileUrl.split("/").pop();
//       const link = document.createElement("a");
//       link.href = URL.createObjectURL(blob);
//       link.download = fileName;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//     } catch (err) {
//       console.error("Download error:", err);
//       alert("Failed to download file. Please try again.");
//     } finally {
//       setDownloading(false);
//     }
//   };

//   const handleNext = () => {
//     if (pagination?.hasNextPage) setCurrentPage((prev) => prev + 1);
//   };

//   const handlePrevious = () => {
//     if (pagination?.hasPreviousPage) setCurrentPage((prev) => prev - 1);
//   };

//   const truncateMessage = (message, limit = 100) => {
//     if (!message) return "";
//     return message.length > limit ? `${message.slice(0, limit)}...` : message;
//   };

//   if (loading) return <Loader />;

//   return (
//     <div className="w-full mx-auto bg-gradient-to-r from-amber-100 via-amber-200 to-amber-100 rounded-2xl shadow-lg p-6 md:p-8 transition-all duration-300">
//       <div className="flex items-center gap-3 mb-4">
//         <div className="bg-amber-500 p-2 rounded-full text-white">
//           <Bell className="w-5 h-5 animate-pulse" />
//         </div>
//         <h2 className="text-lg md:text-xl font-semibold text-amber-800 tracking-wide">
//           Latest Announcements
//         </h2>
//       </div>

//       {error ? (
//         <p className="text-red-600 text-center">{error}</p>
//       ) : announcements.length > 0 ? (
//         announcements.map((announcement) => (
//           <div
//             key={announcement._id}
//             className="bg-white rounded-xl shadow-md p-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border border-amber-200 hover:shadow-xl transition-all duration-300 min-h-[100px]"
//           >
//             {/* Message Section */}
//             <div className="flex items-start gap-3 flex-1">
//               <FileText className="w-6 h-6 text-amber-600 mt-1 shrink-0" />
//               <div className="relative group">
//                 <p
//                   className="text-gray-800 font-medium leading-snug max-w-[600px]"
//                   title={announcement.message}
//                 >
//                   {truncateMessage(announcement.message, 100)}
//                 </p>

//                 {/* Optional Custom Tooltip (Hover Effect) */}
//                 {announcement.message.length > 100 && (
//                   <div className="absolute left-0 z-10 hidden group-hover:block w-72 bg-amber-50 text-amber-800 text-sm p-3 rounded-lg shadow-lg border border-amber-200 mt-2">
//                     {announcement.message}
//                     <div className="absolute -top-2 left-4 w-3 h-3 bg-amber-50 border-t border-l border-amber-200 rotate-45"></div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Download Button */}
//             <button
//               onClick={() => handleDownload(announcement.file)}
//               disabled={downloading}
//               className={`flex items-center gap-2 bg-amber-500 text-white font-semibold px-5 py-2 rounded-full shadow-md hover:bg-amber-600 active:scale-95 transition-all duration-300 shrink-0 ${
//                 downloading ? "opacity-70 cursor-not-allowed" : ""
//               }`}
//             >
//               {downloading ? (
//                 <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-4 h-4"></span>
//               ) : (
//                 <Download className="w-4 h-4" />
//               )}
//               {downloading ? "Downloading..." : "Download File"}
//             </button>
//           </div>
//         ))
//       ) : (
//         <p className="text-gray-600 text-center">No active announcements to display.</p>
//       )}

//       {/* Pagination Controls */}
//       {pagination && (
//         <div className="flex justify-center items-center gap-4 mt-6">
//           <button
//             onClick={handlePrevious}
//             disabled={!pagination.hasPreviousPage || loading}
//             className={`p-2 rounded-full border border-amber-400 hover:bg-amber-100 transition ${
//               !pagination.hasPreviousPage ? "opacity-50 cursor-not-allowed" : ""
//             }`}
//           >
//             <ChevronLeft className="w-5 h-5 text-amber-600" />
//           </button>

//           <span className="text-sm text-gray-700 font-medium">
//             Page {pagination.currentPage} of {pagination.totalPages}
//           </span>

//           <button
//             onClick={handleNext}
//             disabled={!pagination.hasNextPage || loading}
//             className={`p-2 rounded-full border border-amber-400 hover:bg-amber-100 transition ${
//               !pagination.hasNextPage ? "opacity-50 cursor-not-allowed" : ""
//             }`}
//           >
//             <ChevronRight className="w-5 h-5 text-amber-600" />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AnnouncementPanel;


"use client"

import { useEffect, useState } from "react"
import { Bell, Download, ChevronLeft, ChevronRight, FileText } from "lucide-react"
import Loader from "../common/loader"

const AnnouncementPanel = () => {
  const [announcements, setAnnouncements] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [pagination, setPagination] = useState(null)
  const [loading, setLoading] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [error, setError] = useState(null)

  const fetchAnnouncements = async (page = 1) => {
    setLoading(true)
    setError(null)
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/announcement?page=${page}`)
      if (!response.ok) throw new Error("Failed to fetch announcements")
      const data = await response.json()

      if (data.success && data.data.announcements) {
        const activeAnnouncements = data.data.announcements.filter((a) => a.isActive)
        setAnnouncements(activeAnnouncements)
        setPagination(data.data.pagination)
      } else {
        setError("No active announcements found")
      }
    } catch (err) {
      console.error("Error fetching announcements:", err)
      setError(err.message || "Error fetching announcements")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAnnouncements(currentPage)
  }, [currentPage])

  const handleDownload = async (fileUrl) => {
    try {
      setDownloading(true)
      const response = await fetch(fileUrl)
      if (!response.ok) throw new Error("Failed to download file")

      const blob = await response.blob()
      const fileName = fileUrl.split("/").pop()
      const link = document.createElement("a")
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (err) {
      console.error("Download error:", err)
      alert("Failed to download file. Please try again.")
    } finally {
      setDownloading(false)
    }
  }

  const handleNext = () => {
    if (pagination?.hasNextPage) setCurrentPage((prev) => prev + 1)
  }

  const handlePrevious = () => {
    if (pagination?.hasPreviousPage) setCurrentPage((prev) => prev - 1)
  }

  const truncateMessage = (message, limit = 100) => {
    if (!message) return ""
    return message.length > limit ? `${message.slice(0, limit)}...` : message
  }

  if (loading) return <Loader />

  return (
    <div className="container mx-auto mt-6 mb-8 bg-white rounded-xl shadow-sm border border-slate-200 p-6 md:p-8 transition-all duration-300 dark:bg-slate-900 dark:border-slate-800">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-2.5 rounded-lg text-white shadow-md">
          <Bell className="w-5 h-5" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-white">Latest Announcements</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">Stay updated with important platform news</p>
        </div>
      </div>

      {error ? (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700 dark:bg-red-900/20 dark:border-red-800 dark:text-red-400">
          {error}
        </div>
      ) : announcements.length > 0 ? (
        <div className="space-y-3">
          {announcements.map((announcement) => (
            <div
              key={announcement._id}
              className="bg-gradient-to-r from-slate-50 to-white rounded-lg border border-slate-200 p-4 md:p-5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 hover:shadow-md hover:border-slate-300 transition-all duration-300 dark:from-slate-800 dark:to-slate-900 dark:border-slate-700 dark:hover:border-slate-600"
            >
              <div className="flex items-start gap-3 flex-1 min-w-0">
                <div className="bg-blue-100 p-2 rounded-lg shrink-0 dark:bg-blue-900/30">
                  <FileText className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                </div>
                <div className="relative group flex-1 min-w-0">
                  <p
                    className="text-slate-700 font-medium leading-snug text-sm md:text-base dark:text-slate-200"
                    title={announcement.message}
                  >
                    {truncateMessage(announcement.message, 100)}
                  </p>

                  {announcement.message.length > 100 && (
                    <div className="absolute left-0 z-10 hidden group-hover:block w-72 bg-slate-900 text-white text-sm p-3 rounded-lg shadow-lg border border-slate-700 mt-2 dark:bg-slate-800">
                      {announcement.message}
                      <div className="absolute -top-2 left-4 w-3 h-3 bg-slate-900 border-t border-l border-slate-700 rotate-45 dark:bg-slate-800"></div>
                    </div>
                  )}
                </div>
              </div>

              <button
                onClick={() => handleDownload(announcement.file)}
                disabled={downloading}
                className={`flex items-center gap-2 bg-[#ff9906] hover:bg-[#ff9906]/90 text-white font-semibold px-4 py-2 rounded-lg shadow-sm active:scale-95 transition-all duration-300 shrink-0 text-sm md:text-base ${
                  downloading ? "opacity-70 cursor-not-allowed" : ""
                } dark:bg-blue-700 dark:hover:bg-blue-600`}
              >
                {downloading ? (
                  <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-4 h-4"></span>
                ) : (
                  <Download className="w-4 h-4" />
                )}
                {downloading ? "Downloading..." : "Download"}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-slate-50 rounded-lg p-8 text-center dark:bg-slate-800">
          <p className="text-slate-600 dark:text-slate-400">No active announcements to display.</p>
        </div>
      )}

      {pagination && (
        <div className="flex justify-center items-center gap-3 mt-6 pt-6 border-t border-slate-200 dark:border-slate-700">
          <button
            onClick={handlePrevious}
            disabled={!pagination.hasPreviousPage || loading}
            className={`p-2 rounded-lg border border-slate-300 hover:bg-slate-100 transition ${
              !pagination.hasPreviousPage ? "opacity-50 cursor-not-allowed" : ""
            } dark:border-slate-600 dark:hover:bg-slate-800`}
          >
            <ChevronLeft className="w-5 h-5 text-slate-600 dark:text-slate-400" />
          </button>

          <span className="text-sm text-slate-700 font-medium dark:text-slate-300">
            Page {pagination.currentPage} of {pagination.totalPages}
          </span>

          <button
            onClick={handleNext}
            disabled={!pagination.hasNextPage || loading}
            className={`p-2 rounded-lg border border-slate-300 hover:bg-slate-100 transition ${
              !pagination.hasNextPage ? "opacity-50 cursor-not-allowed" : ""
            } dark:border-slate-600 dark:hover:bg-slate-800`}
          >
            <ChevronRight className="w-5 h-5 text-slate-600 dark:text-slate-400" />
          </button>
        </div>
      )}
    </div>
  )
}

export default AnnouncementPanel
